import { Loader2, CheckCircle2 } from "lucide-react";

interface SyncStatusIndicatorProps {
  currentStep: string;
  displayedProgress: number;
  isComplete: boolean;
  error: string | null;
}

const SyncStatusIndicator = ({
  currentStep,
  displayedProgress,
  isComplete,
  error,
}: SyncStatusIndicatorProps) => {
  if (error) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-red-600">
        <span className="truncate max-w-[200px]">{error}</span>
      </div>
    );
  }

  if (isComplete) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-green-600">
        <CheckCircle2 className="h-4 w-4 flex-shrink-0" />
        <span>Successful sync</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Loader2 className="h-4 w-4 animate-spin flex-shrink-0" />
      <span>{displayedProgress}%</span>
      <span className="truncate max-w-[150px]">{currentStep}</span>
    </div>
  );
};

export default SyncStatusIndicator;
